import { render } from "./RecipeTopList.vue?vue&type=template&id=fd05eee6&scoped=true&ts=true"
import script from "./RecipeTopList.vue?vue&type=script&lang=ts"
export * from "./RecipeTopList.vue?vue&type=script&lang=ts"

import "./RecipeTopList.vue?vue&type=style&index=0&id=fd05eee6&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd05eee6"]])

export default __exports__